var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"death-rate-table mt-20"},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.deathData,"pagination":false,"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }